import Icon from '../components/Icon.vue'

Icon.register({"ship":{"width":640,"height":512,"paths":[{"d":"M496.6 372.6L566.6 302.6C583.5 285.7 576.6 256.9 553.8 249.5L512 236.1V96C512 78.3 497.7 64 480 64H416V24C416 10.7 405.3 0 392 0H248C234.7 0 224 10.7 224 24V64H160C142.3 64 128 78.3 128 96V236.1L86.2 249.5C63.5 256.8 56.5 285.7 73.4 302.6L143.4 372.6C125.8 416.3 85.6 448 24 448 10.7 448 0 458.7 0 472V488C0 501.3 10.7 512 24 512 85 512 131.5 491.4 167.3 452.6 181.7 487.4 216 512 256 512H384C424 512 458.3 487.4 472.7 452.6 508.5 491.4 555 512 616 512 629.3 512 640 501.3 640 488V472C640 458.7 629.3 448 616 448 555.2 448 514.5 417 496.6 372.6zM192 128H448V215.5L329.8 177.5A32-32 0 0 1 310.2 177.5L192 215.5V128z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/ship.js
// module id = null
// module chunks = 